module.exports = __webpack_public_path__ + "static/media/QuestionPokoro.ad2a3af1.svg";